/**
 * Products a category listing shows before "Load more", and how many each press adds.
 *
 * The listing config uses it, and so does the server render of the listing, which has to
 * lay the grid out the way the browser will (see ProductListingComponent.serverLimit).
 */
export const CATEGORY_LISTING_STEP = 20;
